exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-input-placeholder{font-size:12px}::-moz-placeholder{font-size:12px}:-ms-input-placeholder{font-size:12px}:-moz-placeholder{font-size:12px}input{vertical-align:middle;padding:0;height:22px;min-height:0;resize:horizontal;white-space:nowrap;display:inline-block;border-bottom:0;width:420px;width:100%}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/output/mail/mail-address/mail-address.component.scss
// module id = 1370
// module chunks = 1